import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import { ChartFormattingMixin } from './concerns/chart_formatting_mixin';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String, title: String, dataFormat: String };
  static targets = ['chartcanvas'];
  Y_AXIS_BUFFER = 2;

  _buildChart() {
    Object.assign(this, ChartFormattingMixin);
    const chartData = JSON.parse(this.inputsValue);

    const chartOptions = {
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          label: 'Productivity Ratio',
          callbacks: {
            label: this.tooltipFormat(),
          },
        },
        title: {
          display: true,
          text: this.titleValue,
          position: 'top',
          align: 'center',
          color: '#ffffff',
        },
      },
      elements: {
        bar: {
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          borderRadius: 5,
        },
      },
      scales: {
        y: {
          type: 'linear',
          grace: this.setGrace(chartData.datasets),
          beginAtZero: false,
          min: this.minYAxis(chartData.datasets[0].data),
          max: this.maxYAxis(chartData.datasets[0].data),

          border: {
            display: false,
          },
          ticks: {
            maxTicksLimit: 3,
            color: '#ffffff',
            callback: (value) => this.tooltipFormat()(value),
          },
        },
        x: {
          border: {
            display: false,
          },
          ticks: {
            maxTicksLimit: 8,
            color: '#ffffff',
            callback: function (value) {
              const label = this.getLabelForValue(value);
              return label.slice(0, 2);
            },
          },
        },
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'bar',
      data: chartData,
      options: chartOptions,
    });
  }

  minYAxis(data) {
    const minYValue = Math.min(...data);
    if (this.dataFormatValue == 'percentage') {
      return Math.max(0, Math.floor(minYValue / 10) * 10);
    } else {
      return Math.max(0, Math.floor(minYValue * (1 - this.Y_AXIS_BUFFER / 100)));
    }
  }

  maxYAxis(data) {
    const maxYValue = Math.max(...data);
    if (this.dataFormatValue == 'percentage') {
      return Math.min(100, Math.ceil(maxYValue / 10) * 10);
    } else {
      return maxYValue * (1 + this.Y_AXIS_BUFFER / 100);
    }
  }
}
